// import os from 'os';

function guessApiHostInterface () {
  console.debug('API host interface: ', window.location.hostname)
  return window.location.hostname
}

const hostname = guessApiHostInterface()
const appUrl = process.env.BACKEND_URL || `http://${hostname}:8000/`

console.debug(`development AppUrl = ${appUrl}`)

export default {
  apiRoot: `${appUrl}api/v1/`,
  vueLogErrors: true,
  sentryDsn: 'https://34e01f055d734640928ff867d1ae0591@sentry.atleta.hu/20',
  routerMode: 'hash'
}
